/**
 * Detect fn
 */
export default () => 'padEnd' in String.prototype
